<template>
    <div>
        <strong style="color: #5A646E" v-text="$ml.get('purchaseSummary')" tabindex="0" />
        <small class="text-secondary d-block mt-2" tabindex="0">{{ MerchantName }}</small>
        <CartItems />
    </div>
</template>

<script>
import CartItems from '@/components/CartItems';
import { mapState } from 'vuex';

export default {
	components: {
		CartItems
	},
	computed: {
		...mapState('preorder', ['MerchantName'])
	}
};
</script>
